
const digest = '7e12614122e51cb6fc3fafda7833920db6faf6fb6e2efe6f78b1eb2f5e292e1c';
const classes = {"wrapper":"_wrapper_1hipw_1"};
const css = `._wrapper_1hipw_1 {
  font-family: Rubik, "sans-serif";
  display: flex;
  flex-direction: column;
  gap: 20px;
  background-color: #fbfbfd;
  margin: -34px -24px;
  padding: 34px 24px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  